import { render, staticRenderFns } from "./TimelineCard.vue?vue&type=template&id=5c23aea9&"
import script from "./TimelineCard.vue?vue&type=script&lang=js&"
export * from "./TimelineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports